module.exports = __webpack_public_path__ + "img/zfb_icon.71765b49.png";